import { Component } from "@angular/core";
import { NvdbNavigationService, RELEASE_NOTES_UID_NVDB_PA_KARTA } from "@app/service/nvdb-navigation.service";
import { TrvModalRef } from "@trv-hub/trv-ng-common";
import { ApplicationInfoModalComponent } from "../application-info-modal/application-info-modal.component";
import { LanguageService } from "@app/service/language.service";


@Component({
    selector: "app-release-notes",
    imports: [],
    templateUrl: "./release-notes.component.html",
    styleUrl: "./release-notes.component.scss"
})
export class ReleaseNotesComponent {
    public releaseNotes = "";

    constructor(
        private modalRef: TrvModalRef<ApplicationInfoModalComponent>,
        public nvdbNavigation: NvdbNavigationService,
        public lang: LanguageService
    ) {
       
    }

    close(): void {
        this.modalRef.close();
    }

    dismiss(): void {
        this.modalRef.dismiss();
    }

}
